/** * Created by lobin on 2019/4/1. */
<template>
  <div class="introduce">
    <div class="detail-single inner home-inner protocol">
        <div class="detail-text">          
            <h1 class="title">蓉e聘-C端职位信息发布规则</h1>
<br/><b>一、前言</b>
<br/>感谢您使用蓉e聘-C端平台！为打造一个合法、安全、公平、真实、准确、效率的招聘求职信息服务平台，我们对蓉e聘-C端职位信息制定了基本的规则。
<br/>本《蓉e聘-C端职位信息发布规则》（以下简称“规则”）系您（指个人或组织）与成都蓉易聘网络科技有限责任公司（以下简称“蓉易聘”或“本平台”）订立的<router-link tag="li" to="/index/userAgreement" >《蓉e聘-C端用户协议》</router-link>的有效组成部分，与<router-link tag="li" to="/index/userAgreement" >《蓉e聘-C端用户协议》</router-link>共同构成您与蓉易聘公司合作的法律文件。
<br/>您在使用蓉易聘的蓉e聘-C端软件填写并发布企业信息、职位信息之前，请务必审慎阅读、充分理解本规则。您使用蓉e聘-C端平台职位信息发布服务的行为，即表示您已阅读并同意本规则所涉全部内容。
<br/>蓉e聘-C端有权根据法律法规、政策及产品需求更新本规则，请您定期访问并查看最新规则。如您继续使用蓉e聘-C端服务的，即表示您接受经修订后的规则。
<br/><b>二、企业信息发布规则</b>
<br/>您应当确保填写的企业相关信息合法、真实、准确，您发布的所有文字、图片、视频等内容，都不得含有任何违法、政治敏感、不符合公序良俗、侵犯他人权益的内容。
<br/>在您填写或修改已有的企业相关信息时，应当遵守的具体规则包括但不限于：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.企业名称、品牌名称、LOGO应当真实有效；品牌名称、LOGO应当与该企业主体具有一致性，或有使用权
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.品牌名称不得与其他知名品牌名称相同或近似
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.公司LOGO应当与公司经营过程中实际使用的LOGO一致，且与其他品牌的使用在先的LOGO不相同或近似
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.公司经营地址应当真实有效，如发生变化应当及时更新
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.公司网址应当真实有效，如发生变化应当及时更新
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.在公司介绍主页上，不得上传与公司无关的图片或涉及联系方式的内容
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.公司介绍的文字内容应当真实、准确、完整，便于求职者理解，不得发布与公司介绍无关的文字内容
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.公司介绍中包含的经营内容应当与公司的经营范围存在一致性
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.产品介绍应当真实、准确、完整，不得将他人产品或产品介绍挪为己用，相关产品应符合公司的经营范围要求
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.提供的高管或个人图片应当真实可辨，不得将他人的照片或无关的图片作为高管照片或个人照片
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11.您发布的信息中不得包含任何其他个人的隐私信息或其他公司的商业信息
<br/><b>三、禁止发布的职位信息</b>
<br/>根据《互联网信息服务管理办法》<a href="https://baike.baidu.com/item/%E7%BD%91%E7%BB%9C%E6%8B%9B%E8%81%98%E6%9C%8D%E5%8A%A1%E7%AE%A1%E7%90%86%E8%A7%84%E5%AE%9A/55577919?fr=ge_ala" target="_blank">《网络招聘服务管理规定》</a>等法律法规，若您发布的职位信息包含以下内容，可能将随时被驳回（部分或全部屏蔽、删除）：
<br/>违法及不良类信息
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.包含违法、涉及国家秘密、政治敏感内容
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.包含色情、淫秽、性暗示或三俗内容，如寻找伴侣、寻求包养等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.包含违反《劳动合同法》等相关法律法规规定的内容，如低于最低工资要求等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.包含性别歧视或指向性歧视、地域歧视等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.包含人身攻击或其他侵害他人权益的内容
<br/>虚假/不明确的信息
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.包含不真实的公司信息
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.包含虚假的招聘者身份信息
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.包含不真实的职位描述、工作内容、薪资或工作地点
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.职位类型与职位描述或与公司经营范围不符的
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.职位名称与职位描述不明确的
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.职位名称包含职位名称以外信息的
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.一个岗位发布多个职位或重复发布相同职位情节严重的
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.发布的职位信息与实际所招聘职位不符
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.包含广告、寻求合作、传销、直销等内容
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.包含微信号、QQ号、手机号等第三方社交账号(或链接)内容
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11.包含鸡汤、段子、水贴等与招聘无关的信息
<br/>违规或高风险类信息
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.兼职模特、试衣模特类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.无经验交易员、分析师类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.涉及套路贷类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.跟剧组类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.演员、练习生、歌手类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.夜场等娱乐会所类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.涉及出海类的职位，如船员、出海捕捞岗位等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.工作地点不在中国境内
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.涉及异地培训/实习的保安类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.信用卡套现类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11.淘宝刷单、微商代理、手机兼职、手工兼职类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12.游戏代练类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13.涉及发布代孕、捐精、捐卵业务
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14.涉及恶意招聘大量（5个以上）兼职主播类职位，内容涉及陪玩陪聊
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;15.挂靠类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16.部分涉及保险业务的职位（内测用户除外）
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;17.兼职推广或为其他平台拉用户的职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18.涉及网络发行、销售彩票类职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;19.有涉黄倾向的模特类的职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20.涉及违规网约车司机、送餐员/外卖骑手的职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;21.被多位用户举报的职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;22.涉及体验师类的职位（含兼职），例如旅游体验师等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;23.涉及发布超越正常工作范围的职位，或职位信息涉及私密关系的情况，如：陪酒、陪吃、陪住、陪玩、陪聊等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;24.其他存在高风险及不符合产品政策的职位
<br/><b>四、禁止实施的行为</b>
<br/>本平台严禁用户利用蓉e聘-C端的招聘和求职服务服务，在发布职位、邀约面试等各项环节，实施下述行为。如您/您的关联账号存在下述行为，您的职位信息（免费、付费）均有可能无法审核通过或被删除/屏蔽；您的账号可能被暂时或永久冻结：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.实施任何辱党、辱国、传播邪教思想等违法及违背公序良俗的行为
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.在平台内使用涉及各国政治人物的图片
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.在平台内使用含色情、淫秽内容的图片
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.在平台内使用人身攻击或其他侵害他人权益的图片
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.通过非蓉e聘-C端开发、授权的第三方软件、插件、外挂或系统或其他不正常的方式，登录、使用蓉e聘-C端平台服务，影响或可能影响蓉e聘-C端平台管理运营秩序的
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.以培训费、服装费、工作需要等任何名义向求职者索要财物、收取求职者费用、引导求职者贷款、引导求职者入金等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.实施传销活动或骗取他人加入传销组织
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.招聘他人从事违法违规、违背公序良俗的活动，包括但不限于学术造假、作弊、替考、刷单、赌博等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.非基于自身招聘目的，或违反平台要求，直接或变相索取用户个人信息
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.恶意骚扰其他用户
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11.利用平台可能存在的漏洞进行“撸羊毛”、在第三方售卖前述道具产品
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12.在平台内使用涉及广告（寻求合作）、营销的头像或宣传图片
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13.无RPO业务但帮其他公司招聘的行为
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14.以招聘名义招人培训
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;15.个体工商户发布异地职位的行为
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16.所招聘岗位无薪资或存在涉及拒发或恶意拖欠工资的行为
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;17.招聘未满16周岁人员
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18.发布涉及违规网约车司机、违规送餐员/外卖骑手等相关信息的行为
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;19.未通过平台功能与用户交换联系方式或诱导用户站外求职招聘，例如发送包含社交账号/通信方式（例如微信号/QQ号/手机号/第三方网站链接等）的开聊信息、发布包含前述内容的职位
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20.其他违反法律法规、违背公序良俗、对抗平台规则、破坏平台秩序等不当行为
<br/><b>五、暂不提供服务的企业类型</b>
<br/>本平台暂不为存在以下情况的公司提供职位发布服务。因此，您可能无法发布此类公司的介绍信息，无法发布相关的职位信息，或/和该信息在发布后被平台驳回/删除/屏蔽：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.所招聘岗位无薪资或公司存在涉及拒发或恶意拖欠工资的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.涉及以招聘名义招人培训的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.存在刷单、微商代理、手机兼职、手工兼职业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.存在跟剧组行为的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.存在兼职模特、试衣模特业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.存在培养演员、练习生、歌手业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.存在需要求职者去境外工作的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.主营业务为夜场等娱乐场所的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.涉及收取求职者费用、引导求职者贷款、引导求职者入金的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.涉及色情、淫秽、性暗示或三俗内容的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11.存在直销或传销模式业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12.存在信用卡套现的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13.存在挂靠业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14.存在涉及套路贷业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;15.在国家企业信用信息公示系统中的登记状态为注销/吊销状态的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16.在国家企业信用信息公示系统中被列入经营异常名录，情节严重的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;17.在国家企业信用信息公示系统中查询不到注册信息的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18.已被法院判定为破产或正在进行破产申请流程的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;19.在媒体、网站或社交平台等渠道中查询到涉嫌存在严重失信、违法违规或违反平台规则（指您与成都蓉易聘公司签署的包括但不限于<router-link tag="li" to="/index/userAgreement" >《蓉e聘-C端用户协议》</router-link>及本规则）等相关行为的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20.被多位用户举报的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;21.涉及代孕、捐精、捐卵的业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;22.涉及恶意招聘大量兼职主播或业务涉及陪玩陪聊的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;23.涉及招聘无经验交易员、分析师的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;24.未认证通过的人资公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;25.涉及保险业务的公司（除内测用户以外）
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;26.存在涉及虚拟/数字货币交易的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;27.涉及兼职推广或为其他平台拉用户等业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;28.涉嫌从事网络发行、销售彩票相关业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;29.涉嫌非法经营或从事违法违规、违背公序良俗业务的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;30.发布模特职位且有涉黄倾向的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;31.发布异地培训/实习的保安职位的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;32.发布违规网约车司机、送餐员/外卖骑手职位的公司
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;33.发布涉及体验师类职位（含兼职）的公司，例如旅游体验师等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;34.发布涉及出海类职位的公司，例如船员、出海捕捞岗位等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;35.发布超越正常工作范围的职位，或职位信息包含私密关系的公司，如在职位描述中包括陪酒、陪吃、陪住、陪玩、陪聊等
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;36.其他基于保护求职者安全等原因无法提供服务的公司
<br/><b>六、违规处罚规则</b>
<br/>1.本平台有权对用户发布的企业信息、职位信息进行审核，对于不符合本规则的内容，有权采取拒绝发布、部分或全部删除等处理措施。
<br/>2.用户违反前述第二条、第三条、第四条规定的内容，或者有其他可能损害蓉e聘-C端利益或违法行为的，蓉e聘-C端公司有权视情节采取，包括但不限于冻结您的账户的方式暂时乃至永久停止您使用蓉e聘-C端招聘服务、禁言、限制部分或全部功能的使用、取消预约面试等处理措施。如用户行为涉嫌违法犯罪的，蓉易聘公司有权向有关行政机关及司法部门举报、披露相关信息。
<br/>3.您或您的关联账号涉嫌违反本规则，或者有其他明显损害蓉易聘公司利益或违法行为的，经本平台发现或用户投诉后核实的，蓉易聘公司有权视情节采取冻结账户的方式暂时乃至永久停止您使用蓉e聘-C端服务等处理措施。
<br/>4.如您的行为给蓉易聘公司造成损失的，蓉易聘公司有权要求您赔偿全部的损失；如涉嫌违法犯罪的，蓉易聘公司有权向有关行政机关及司法部门举报、披露相关信息。
<br/>5.如企业招聘者违反本规则的情节严重的，蓉易聘公司有权冻结该企业，即不为该企业提供相关服务。
<br/>6.为防止信息泄露，保障蓉e聘-C端平台的稳定及安全，任何用户不得使用任何相关招聘管理系统/插件/外挂/工具/ATS，包括但不限于北森、大易、moka、图谱、云招、e成等，访问或接入蓉e聘-C端系统及/或获取蓉e聘-C端免费及付费服务（包括但不限于登录蓉e聘-C端账号、发布职位、浏览职位、收发简历、筛选匹配、定向推送消息、自动沟通等）。
<br/>7.用户违反本规则的，本平台可以依据本规则直接采取相关措施，并视情节严重程度选择是否通知用户。接到通知的用户可以通过“锁定通知”页面显示的渠道向本平台提交申诉。
<br/><b>七、其他规则</b>
<br/>1.定义：
<br/>本规则所称“异地职位”指工作地点与招聘主体（指蓉e聘-C端认证的企业）营业执照地址不一致或不在同一城市的招聘信息。
<br/>本规则所称“违规网约车司机、送餐员/外卖骑手类职位”指无经营许可，擅自从事或者变相从事网约车平台、外卖平台或其他类似业务的招聘用户，发布涉及招聘网约车司机、送餐员/外卖骑手的职位信息。
<br/>本规则所称“安保服务”指包括但不限于《保安服务管理条例》规定的从事门卫、巡逻、守护、押运、随身护卫等安全防范的工作，或提供安全检查/安全技术防范/安全风险评估/秩序维护等服务。
<br/>本规则所称“人资公司”是指经营范围包含人力资源/劳务派遣、实际存在代招或实际从事人力资源/劳务派遣业务的招聘企业。
<br/>1.所有职位均设置了有效期限，本平台有权对不同的职位类别下职位信息设置不同的有效期，有效期届满时该职位信息可能被下线。
<br/>2.本平台有权根据法律法规、政策及产品需求更新本规则，并在平台内予以公布。新的规则自公布之日起生效。

        </div>
        

    </div>
  </div>
</template>

<script type="text/babel">
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.introduce {
  padding-top: 20px;
  line-height: 26px;
  color: #414a60;
  font-size: 14px;
  //margin-bottom: 40px;
  //text-indent: 2em; /* 2个字符的宽度 */
  .protocol {
    background: #fff;
    margin: 37px auto 55px auto;
    padding: 15px 45px 65px 45px;
    min-height: calc(100% - 330px);
    box-sizing: border-box;
  }
  .home-inner {
    max-width: 1200px;
  }
  .inner {
    max-width: 1200px;
    margin: 0 auto;
  }
}
.protocol h1 {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 25px;
  font-size: 20px;
}
b{
    font-size: 16px;
}
p{
    padding: 0 !important;
    margin: 0 !important;
    font-weight: 600;
}
li{
    list-style: none;
    display: inline-block;
    color: #049cfd;
    font-weight: 600;
    cursor: pointer;
}
</style>
